;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { cn } from '@workspace/ui/lib';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

const badgeVariants = cva('rounded-[80px] inline-flex justify-center items-center gap-1', {
  variants: {
    variant: {
      green: 'text-green-500 dark:text-green-400 px-0! py-0!',
      'light-grey': 'text-grey-500 dark:text-grey-400 px-0! py-0!',
      orange: 'text-orange-500 px-0! py-0!',
      red: 'text-red-500 px-0! py-0!',
      blue: 'text-blue-500 dark:text-blue-400 px-0! py-0!',
      purple: 'text-purple-500 px-0! py-0!',
      'dark-grey': 'text-grey-700 px-0! py-0!',
      'light-yellow': 'text-yellow-500 px-0! py-0!',
      'light-blue-1': 'text-blue-400 px-0! py-0!',
      'light-blue-2': 'text-blue-500 px-0! py-0!',
      'light-purple': 'text-purple-500 px-0! py-0!',
      'light-orange': 'text-orange-500 px-0! py-0!',
      'light-red': 'text-red-500 px-0! py-0!',
      'filled-green': 'text-neutral-100 bg-green-500',
      'filled-blue': 'text-neutral-100 bg-blue-500',
      'filled-red': 'text-neutral-100 bg-red-400',
      'filled-pink': 'text-neutral-100 bg-pink-300',
      'filled-pink-2': 'text-neutral-100 bg-pink-500',
      'filled-grey':
        'text-grey-800 bg-grey-200 dark:text-grey-800 [&_button]:dark:text-neutral-200 [&_button]:dark:hover:text-grey-1100 [&_button]:dark:focus-visible:text-grey-1100 [&_button]:dark:active:text-grey-1100',
      'filled-grey-2': 'text-grey-600 bg-grey-100 dark:text-grey-600',
      'filled-light-green': 'text-green-500 bg-green-100',
      'filled-light-blue-1': 'text-blue-400 bg-blue-100',
      'filled-light-blue-2': 'text-blue-500 bg-blue-200',
      'filled-dark-blue': 'text-blue-100 bg-blue-600',
      'filled-light-purple': 'text-purple-500 bg-purple-200',
      'filled-light-yellow': 'text-yellow-500 bg-orange-100',
      'filled-light-orange': 'text-orange-500 bg-orange-100',
      'filled-dark-orange': 'text-[#B25F00] bg-orange-200',
      'filled-light-pink': 'text-pink-400 bg-pink-50',
      'filled-light-teal': 'text-teal-800 bg-teal-100',
      'filled-light-red': 'text-red-400 bg-red-100',
      'filled-dark-red': 'text-red-600 bg-red-100',
    },
    size: {
      lg: 'py-1 px-3 [&_[data-badge-text]]:text-sm [&>div>svg]:w-5 [&>div>svg]:h-5',
      m: 'py-1 px-3 [&_[data-badge-text]]:text-xs [&>div>svg]:w-4 [&>div>svg]:h-4 max-h-[24px]',
      sm: 'py-1 px-2 [&_[data-badge-text]]:text-[8px] [&>div>svg]:w-2 [&>div>svg]:h-2 max-h-[16px]',
    },
  },
  defaultVariants: {
    variant: 'green',
    size: 'm',
  },
});

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
  iconAfter?: React.ReactNode;
  text?: string;
  variant?:
    | 'green'
    | 'light-grey'
    | 'orange'
    | 'red'
    | 'blue'
    | 'purple'
    | 'dark-grey'
    | 'filled-green'
    | 'filled-blue'
    | 'filled-red'
    | 'filled-pink'
    | 'filled-pink-2'
    | 'filled-grey'
    | 'filled-grey-2'
    | 'filled-light-green'
    | 'filled-light-blue-1'
    | 'filled-light-blue-2'
    | 'filled-dark-blue'
    | 'filled-light-purple'
    | 'filled-light-yellow'
    | 'filled-light-orange'
    | 'filled-light-pink'
    | 'filled-light-teal'
    | 'light-yellow'
    | 'light-blue-1'
    | 'light-blue-2'
    | 'light-purple'
    | 'light-orange'
    | 'filled-dark-orange'
    | 'light-red'
    | 'filled-light-red'
    | 'filled-dark-red';
  textClassName?: string;
  children?: React.ReactNode;
}

function Badge({
  className,
  variant,
  size,
  icon,
  iconAfter,
  text,
  textClassName,
  children,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), 'inline-flex items-center gap-1', className)}
      {...props}
    >
      {icon && <div className="flex items-center justify-center">{icon}</div>}
      <div data-badge-text className="flex items-center justify-center font-medium">
        <p className={cn(textClassName)}>{children || text}</p>
      </div>
      {iconAfter && <div className="flex items-center justify-center">{iconAfter}</div>}
    </div>
  );
}

export { Badge, badgeVariants };
